import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      const $components = document.querySelectorAll( '[data-component="vc-cta"]' );

      $components.forEach( ( component ) => {
        const pills = component.querySelectorAll( '.vc-cta__pill' );

        pills.forEach( ( pill, index ) => {
          const maxMovement = 25 + index * 5;
          const direction = index % 2 === 0 ? 1 : -1;

          gsap.to( pill, {
            y: direction * maxMovement,
            ease: 'sine.inOut',
            scrollTrigger: {
              trigger: component,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 2,
            },
          } );
        } );
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'vc-cta', COMPONENT );
} )( app );
